import { useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { EntityPageHeader } from '@/shared/components'
import { TypeActiviteForm } from '../components'
import { useTypeActivite, useCreateTypeActivite, useUpdateTypeActivite } from '../hooks/use-types-activite'

export function TypeActiviteFormPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { t } = useTranslation()
  const isEdit = !!id

  const { data: typeActivite, isLoading } = useTypeActivite(id ? parseInt(id) : undefined)
  const createType = useCreateTypeActivite()
  const updateType = useUpdateTypeActivite()

  const handleSubmit = (data: { code: string; libelle: string; couleur?: string; actif: boolean }) => {
    if (isEdit) {
      updateType.mutate(
        { id: parseInt(id!), data: { ...data, id: parseInt(id!) } },
        { onSuccess: () => navigate('/administration/types-activite') },
      )
    } else {
      createType.mutate(data, {
        onSuccess: () => navigate('/administration/types-activite'),
      })
    }
  }

  if (isEdit && isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    )
  }

  return (
    <div>
      <EntityPageHeader
        title={
          isEdit
            ? t('administration.sections.activities.editTitle', "Modifier l'activité")
            : t('administration.sections.activities.createTitle', 'Créer une activité')
        }
        backTo="/administration/types-activite"
      />
      <TypeActiviteForm
        typeActivite={typeActivite}
        onSubmit={handleSubmit}
        isPending={createType.isPending || updateType.isPending}
      />
    </div>
  )
}
